import { useAuth } from "../auth/AuthContext";
import { ReactComponent as UserIcon } from "../../../assets/userIcon.svg";
import React, { useState } from "react";
import logo from "../../../assets/sq-logo.png";

const MenuBar: React.FC = () => {
  const { user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const handleMenu = () => setMenuOpen((prev) => !prev);
  const handleClose = () => setMenuOpen(false);

  return (
    <header className="sticky top-0 bg-gray-950 font-Poppins text-white shadow-md z-50">
      <div className="flex items-center justify-between px-4 py-2">
        {/* Logo on the left */}
        <div className="flex items-center flex-shrink-0">
          <img src={logo} alt="Logo" className="h-12 w-12 rounded-lg" />
        </div>

        {/* App Name in the center */}
        <div className="font-Poppins tracking-wide upp text-xl font-semibold text-center">
          Secured Calls Admin Portal
        </div>

        {/* User Avatar and Dropdown */}
        <div className="relative">
          {/* Avatar */}
          <button
            onClick={handleMenu}
            className="flex items-center justify-center p-2 text-white gap-4"
          >
            <UserIcon className="w-5 h-5"></UserIcon>
            <span className="font-Poppins font-semibold">
              {user?.givenName ?? "U"} {user?.familyName ?? "U"}
            </span>
          </button>

          {/* Dropdown Menu */}
          {menuOpen && (
            <div
              className="absolute right-0 mt-2 w-32 bg-white rounded-lg shadow-lg text-gray-700"
              onMouseLeave={handleClose}
            >
              <ul>
                <li>
                  <button
                    onClick={logout}
                    className="block w-full text-left px-4 py-2 hover:bg-gray-200"
                  >
                    Logout
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default MenuBar;
